module.exports = __webpack_public_path__ + "assets/img/22_1337_big.90677c88.jpg";